import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const API = import.meta.env.VITE_API_URL || '/api';

export default function CustomerLogin() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('login');
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [regForm, setRegForm] = useState({ name: '', email: '', phone: '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ── If already logged in, skip straight to dashboard ──
  useEffect(() => {
    const token = localStorage.getItem('customer_token');
    if (token) navigate('/account/dashboard', { replace: true });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    const r = await fetch(`${API}/customer-login.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(loginForm),
    }).then(r => r.json()).catch(() => ({ success: false, message: 'Network error' }));
    setLoading(false);
    if (r.success) {
      localStorage.setItem('customer_token', r.token);
      localStorage.setItem('customer_data', JSON.stringify(r.customer));
      // Notify Header to update the Account link immediately
      window.dispatchEvent(new Event('storage'));
      navigate('/account/dashboard', { replace: true });
    } else setError(r.message || 'Login failed');
  };

  const handleRegister = async (e) => {
    e.preventDefault(); setError(''); setSuccess('');
    if (regForm.password !== regForm.confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    const r = await fetch(`${API}/customer-register.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: regForm.name, email: regForm.email, phone: regForm.phone, password: regForm.password }),
    }).then(r => r.json()).catch(() => ({ success: false, message: 'Network error' }));
    setLoading(false);
    if (r.success) {
      setSuccess('✅ Account created! Please login.');
      setTab('login');
      setLoginForm({ email: regForm.email, password: '' });
    } else setError(r.message || 'Registration failed');
  };

  const inp = (value, onChange, type, placeholder, required = true) => (
    <input type={type} value={value} onChange={onChange} placeholder={placeholder} required={required}
      style={{ width:'100%', padding:'.85rem 1rem', background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,184,0,.25)', borderRadius:6, color:'#FFE082', fontFamily:"'Crimson Pro',serif", fontSize:'1rem', outline:'none', boxSizing:'border-box', marginBottom:'1rem' }} />
  );

  return (
    <div style={{ minHeight:'80vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem 1rem' }}>
      <div style={{ width:'100%', maxWidth:440 }}>

        <div style={{ textAlign:'center', marginBottom:'2rem' }}>
          <Link to="/" style={{ textDecoration:'none' }}>
            <span style={{ fontSize:'2.5rem', animation:'glow 3s ease-in-out infinite' }}>ॐ</span>
            <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'1.3rem', background:'linear-gradient(135deg,#FFE082,#FF6B00)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', marginTop:'.3rem' }}>CosmicHindu</div>
          </Link>
        </div>

        <div style={{ background:'linear-gradient(135deg,rgba(20,4,0,.96),rgba(26,10,46,.96))', border:'1px solid rgba(255,184,0,.25)', borderRadius:12, overflow:'hidden' }}>
          {/* Tabs */}
          <div style={{ display:'flex' }}>
            {['login','register'].map(t => (
              <button key={t} onClick={() => { setTab(t); setError(''); setSuccess(''); }}
                style={{ flex:1, padding:'1rem', fontFamily:"'Cinzel',serif", fontSize:'.72rem', letterSpacing:'.15em', textTransform:'uppercase', border:'none', cursor:'pointer', background: tab===t ? 'rgba(255,107,0,.15)' : 'transparent', color: tab===t ? '#FFB800' : 'rgba(255,224,130,.4)', borderBottom: tab===t ? '2px solid #FF6B00' : '2px solid transparent', transition:'all .2s' }}>
                {t === 'login' ? '🔑 Login' : '✨ Register'}
              </button>
            ))}
          </div>

          <div style={{ padding:'2rem' }}>
            {error   && <div style={{ padding:'.75rem 1rem', borderRadius:6, marginBottom:'1rem', background:'rgba(192,57,43,.15)', border:'1px solid rgba(192,57,43,.3)', fontFamily:"'Cinzel',serif", fontSize:'.73rem', color:'#ff6b6b' }}>⚠️ {error}</div>}
            {success && <div style={{ padding:'.75rem 1rem', borderRadius:6, marginBottom:'1rem', background:'rgba(76,175,80,.15)', border:'1px solid rgba(76,175,80,.3)', fontFamily:"'Cinzel',serif", fontSize:'.73rem', color:'#4CAF50' }}>{success}</div>}

            {tab === 'login' ? (
              <form onSubmit={handleLogin}>
                {inp(loginForm.email,    e => setLoginForm({...loginForm, email:e.target.value}),    'email',    'Your email address')}
                {inp(loginForm.password, e => setLoginForm({...loginForm, password:e.target.value}), 'password', 'Your password')}
                <button type="submit" disabled={loading}
                  style={{ width:'100%', padding:'1rem', fontFamily:"'Cinzel',serif", fontSize:'.82rem', fontWeight:700, letterSpacing:'.18em', textTransform:'uppercase', background: loading ? 'rgba(255,107,0,.4)' : 'linear-gradient(135deg,#FF6B00,#FFB800)', color:'#0D0500', border:'none', borderRadius:6, cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? '🌀 Signing in…' : '🙏 Sign In'}
                </button>
              </form>
            ) : (
              <form onSubmit={handleRegister}>
                {inp(regForm.name,    e => setRegForm({...regForm, name:e.target.value}),    'text',     'Your full name')}
                {inp(regForm.email,   e => setRegForm({...regForm, email:e.target.value}),   'email',    'Your email address')}
                {inp(regForm.phone,   e => setRegForm({...regForm, phone:e.target.value}),   'tel',      'Phone number (optional)', false)}
                {inp(regForm.password,e => setRegForm({...regForm, password:e.target.value}),'password', 'Create password')}
                {inp(regForm.confirm, e => setRegForm({...regForm, confirm:e.target.value}), 'password', 'Confirm password')}
                <button type="submit" disabled={loading}
                  style={{ width:'100%', padding:'1rem', fontFamily:"'Cinzel',serif", fontSize:'.82rem', fontWeight:700, letterSpacing:'.18em', textTransform:'uppercase', background: loading ? 'rgba(255,107,0,.4)' : 'linear-gradient(135deg,#FF6B00,#FFB800)', color:'#0D0500', border:'none', borderRadius:6, cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? '🌀 Creating account…' : '✨ Create Account'}
                </button>
              </form>
            )}
          </div>
        </div>

        <div style={{ textAlign:'center', marginTop:'1.5rem' }}>
          <Link to="/shop" style={{ fontFamily:"'Cinzel',serif", fontSize:'.68rem', letterSpacing:'.12em', textTransform:'uppercase', color:'rgba(255,224,130,.4)', textDecoration:'none' }}>← Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
